import { Restaurant } from '@lib/types';
import { createAction, props } from '@ngrx/store';

export const loadRestaurants = createAction(
  '[RestaurantManager] Load Restaurants'
);

export const loadRestaurantsSuccess = createAction(
  '[RestaurantManager] Load Restaurants Success',
  props<{ restaurants: Restaurant[] }>()
);

export const loadRestaurantsFailure = createAction(
  '[RestaurantManager] Load Restaurants Failure',
  props<{ error: any }>()
);

export const loadRestaurant = createAction(
  '[RestaurantManager] Load Restaurant',
  props<{ id: number }>()
);

export const loadRestaurantSuccess = createAction(
  '[RestaurantManager] Load Restaurant Success',
  props<{ restaurant: Restaurant }>()
);

export const loadRestaurantFailure = createAction(
  '[RestaurantManager] Load Restaurant Failure',
  props<{ error: any }>()
);

export const updateRestaurant = createAction(
  '[RestaurantManager] Update Restaurant',
  props<{ restaurant: Restaurant }>()
);

export const updateRestaurantSuccess = createAction(
  '[RestaurantManager] Update Restaurant Success',
  props<{ restaurant: Restaurant }>()
);

export const updateRestaurantFailure = createAction(
  '[RestaurantManager] Update Restaurant Failure',
  props<{ error: any }>()
);
